/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Project } from './Project';
import {
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
    ProjectToJSONTyped,
} from './Project';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';
import type { ContentTag } from './ContentTag';
import {
    ContentTagFromJSON,
    ContentTagFromJSONTyped,
    ContentTagToJSON,
    ContentTagToJSONTyped,
} from './ContentTag';
import type { ExpenseType } from './ExpenseType';
import {
    ExpenseTypeFromJSON,
    ExpenseTypeFromJSONTyped,
    ExpenseTypeToJSON,
    ExpenseTypeToJSONTyped,
} from './ExpenseType';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { Attachment } from './Attachment';
import {
    AttachmentFromJSON,
    AttachmentFromJSONTyped,
    AttachmentToJSON,
    AttachmentToJSONTyped,
} from './Attachment';

/**
 * 
 * @export
 * @interface Expense
 */
export interface Expense {
    /**
     * 
     * @type {string}
     * @memberof Expense
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Expense
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Expense
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Expense
     */
    occurredAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Expense
     */
    amount: number;
    /**
     * 
     * @type {PaymentType}
     * @memberof Expense
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof Expense
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Expense
     */
    comments?: string;
    /**
     * 
     * @type {Project}
     * @memberof Expense
     */
    project: Project;
    /**
     * 
     * @type {ExpenseType}
     * @memberof Expense
     */
    type: ExpenseType;
    /**
     * 
     * @type {Array<Message>}
     * @memberof Expense
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {User}
     * @memberof Expense
     */
    createdBy?: User;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof Expense
     */
    attachments?: Array<Attachment>;
    /**
     * 
     * @type {Array<ContentTag>}
     * @memberof Expense
     */
    tags?: Array<ContentTag>;
}

/**
 * Check if a given object implements the Expense interface.
 */
export function instanceOfExpense(value: object): value is Expense {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('project' in value) || value['project'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ExpenseFromJSON(json: any): Expense {
    return ExpenseFromJSONTyped(json, false);
}

export function ExpenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Expense {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'occurredAt': json['occurred_at'] == null ? undefined : (new Date(json['occurred_at'])),
        'amount': json['amount'],
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'name': json['name'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'project': ProjectFromJSON(json['project']),
        'type': ExpenseTypeFromJSON(json['type']),
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'createdBy': json['createdBy'] == null ? undefined : UserFromJSON(json['createdBy']),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(AttachmentFromJSON)),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(ContentTagFromJSON)),
    };
}

export function ExpenseToJSON(json: any): Expense {
    return ExpenseToJSONTyped(json, false);
}

export function ExpenseToJSONTyped(value?: Expense | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'occurred_at': value['occurredAt'] == null ? undefined : ((value['occurredAt']).toISOString()),
        'amount': value['amount'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'name': value['name'],
        'comments': value['comments'],
        'project': ProjectToJSON(value['project']),
        'type': ExpenseTypeToJSON(value['type']),
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(MessageToJSON)),
        'createdBy': UserToJSON(value['createdBy']),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(AttachmentToJSON)),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(ContentTagToJSON)),
    };
}

